var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex px-5 py-3 container justify-content-center flex-column",
    },
    [
      _c(
        "div",
        [
          _vm.currentJob.state === "completed"
            ? _c("meta-data-table", {
                attrs: {
                  "first-file": _vm.currentJob.apiJob?.input[0],
                  "second-file": _vm.currentJob.apiJob?.input[1],
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.metrics !== null
            ? _c("video-quality-factor-table", {
                attrs: { "pooled-metrics": _vm.metrics },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }